import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import PropTypes from 'prop-types';
import React from 'react';

import { Button } from 'components/AORedesign';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  container: {
    maxHeight: '400px',
    overflow: 'auto',
  },
});

const Row = (props) => {
  const { columns, row, handleSetUsername } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();
  const username = row?.userName;
  const rowId = 'search-user-result-' + username?.toLowerCase();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell width={100}>
          {row?.agencyNames.length > 0 && (
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>

        <TableCell>
          {handleSetUsername ? (
            <Button color="primary" id={rowId} onClick={() => handleSetUsername(username)} variant="text">
              {username}
            </Button>
          ) : (
            <Button color="primary" id={rowId} variant="text">
              {username}
            </Button>
          )}
        </TableCell>

        {columns.map((column, index) => index > 0 && <TableCell key={`${index}-${row.userName}`}>{row[column.field]}</TableCell>)}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1} pl={18}>
              {row?.agencyNames.map((agency, index) => (
                <Typography key={`${index}-${agency}`}>
                  <Box fontSize={'0.75rem'}>{agency}</Box>
                </Typography>
              ))}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

Row.propTypes = {
  columns: PropTypes.array.isRequired,
  handleSetUsername: PropTypes.func,
  row: PropTypes.object.isRequired,
};

const CollapsibleTable = ({ columns, handleSetUsername, rows }) => {
  const classes = useRowStyles();

  return rows.length ? (
    <>
      <Divider />
      <Box display={'flex'} justifyContent="space-between" alignItems="center" my={2}>
        <Typography variant="h6">Search Result </Typography>
      </Box>

      <TableContainer component={Paper} className={classes.container}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              {columns.map((column, index) => (
                <TableCell key={`${index}-${column.field}`}>{column.headerName}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <Row key={`${row?.userName}`} columns={columns} row={row} handleSetUsername={handleSetUsername} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  ) : (
    <Typography color={'error'}>No user found for search criteria.</Typography>
  );
};

CollapsibleTable.propTypes = {
  columns: PropTypes.array.isRequired,
  handleSetUsername: PropTypes.func,
  rows: PropTypes.array.isRequired,
};

export default CollapsibleTable;
